import React from 'react';

import {
  useJobDescriptionsFromExternalWebsitesState,
  useJobDescriptionsFromExternalWebsitesActions
} from './JobDescriptionsFromExternalWebsitesContext';

import {
  getJobDescriptionsFromExternalWebsites,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const JobDescriptionsFromExternalWebsitesPageController = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { onResponse, onError } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <PageController
      pageNumber={jobDescriptionsFromExternalWebsitesState?.pageNumber}
      numberOfPages={jobDescriptionsFromExternalWebsitesState?.numberOfPages}
      goToFirstPage={() => {
        getJobDescriptionsFromExternalWebsites({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: 1,
          },
        });
      }}
      goToPreviousPage={() => {
        getJobDescriptionsFromExternalWebsites({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (jobDescriptionsFromExternalWebsitesState?.pageNumber - 1),
          },
        });
      }}
      goToNextPage={() => {
        getJobDescriptionsFromExternalWebsites({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: (jobDescriptionsFromExternalWebsitesState?.pageNumber + 1),
          },
        });
      }}
      goToLastPage={() => {
        getJobDescriptionsFromExternalWebsites({
          onResponse,
          onError,
          body: {
            authenticityToken,
            pageNumber: jobDescriptionsFromExternalWebsitesState?.numberOfPages,
          },
        });
      }}
    />
  );
};

export default JobDescriptionsFromExternalWebsitesPageController;